import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface permissionsDetail {
    id: number;
    name: string;
    codename: string;
}

interface GroupPermissionsDetailState {
    id: number;
    name: string;
    description: string;
    code: string;
    status: 0 | 1;
    permissions: permissionsDetail[];
    created_at: string;
    updated_at: string;
}

interface GroupPermissionsData {
    groupPermissionsList: GroupPermissionsDetailState[];
}

const initialState: any = {
    groupPermissionsList: [],
    groupPermissionsCreation: {},
    loading: false,
    permissionsList: [],
    loadingPermissions: false,
    success: false,
};

const groupPermissionsSlice = createSlice({
    name: 'groupPermissions',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setSuccess(state, action) {
            state.success = action.payload;
        },
        setGroupPermissionsList(state, action) {
            state.groupPermissionsList = action.payload;
        },
        setGroupPermissionsCreation(state, action) {
            state.groupPermissionsCreation = action.payload;
        },
        clearGroupPermissionsData(state) {
            state.groupPermissionsList = [];
            state.groupPermissionsCreation = {}
        },
        setPermissionsList(state, action: PayloadAction<any>) {
            state.permissionsList = action.payload
        },
        setLoadingPermissions(state, action: PayloadAction<any>) {
            state.loadingPermissions = action.payload
        }
    },
});

export const {
    setLoading,
    setSuccess,
    setGroupPermissionsList,
    setGroupPermissionsCreation,
    clearGroupPermissionsData,
    setPermissionsList,
    setLoadingPermissions
} = groupPermissionsSlice.actions;

export default groupPermissionsSlice.reducer;
